import { Alert, AlertTitle } from "@material-ui/lab";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles({
  root: {
    margin: "2% 8% 2% 8%",
    backgroundColor: "#fffbeb",
    border: "2px solid #fbbf24",
    borderRadius: 12,
    color: "#92400e",
    "& .MuiAlert-icon": {
      color: "#fbbf24",
    },
  },
});

const AttentionMessage = ({ title, message }) => {
  const classes = useStyles();
  return (
    <Alert severity="warning" className={classes.root}>
      <AlertTitle style={{ color: "#78350f", fontWeight: 600 }}>
        {title}
      </AlertTitle>
      {message}
    </Alert>
  );
};

export default AttentionMessage;
